
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/mobile-application-development",
      function () {
        return require("private-next-pages/services/mobile-application-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/mobile-application-development"])
      });
    }
  